/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { Tabs } from 'antd'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import { observer, inject } from 'mobx-react'
import { compose } from 'recompose'

import DTR from './DTR'
import VisitorLogs from './VisitorLogs'
import Constituents from './Constituents'
import Households from './Household'
import Project from './Projects'
import Events from './Events'
import FacilityReservation from './FacilityReservations'
import Equipments from './Equipments'
import Certificates from './Certificates'
import Household from './Household'

const { TabPane } = Tabs

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
		}
	}

	render() {
		// const { AuthStore } = this.props
		// const { barangay_uid } = AuthStore
		
		return (
			<React.Fragment>
				<div className="row">
					<div className="col-12">
						<div className="page-title-box">
							<div className="page-title-right">
								<ol className="breadcrumb m-0">
									<li className="breadcrumb-item"><Link to='/'>Dashboard</Link></li>
									<li className="breadcrumb-item active">Queries & Reports</li>
								</ol>
							</div>
							<h4 className="page-title">Queries & Reports</h4>
						</div>
					</div>
				</div>
				<div className="row">
					<div className="col-12">
						<div className='card'>
							<div className='card-body'>
								<Tabs defaultActiveKey="households">
									<TabPane tab="Households" key="households">
										<Household />
									</TabPane>
									<TabPane tab="Constituents" key="constituents">
										<Constituents />
									</TabPane>
									<TabPane tab="Daily Time Record" key="dtr">
										<DTR />
									</TabPane>
									<TabPane tab="Visitor Logs" key="visitor-logs">
										<VisitorLogs />
									</TabPane>
									<TabPane tab="Barangay Projects" key="projects">
										<Project />
									</TabPane>
									<TabPane tab="Events" key="events">
										<Events />
									</TabPane>
									<TabPane tab="Facility Reservation" key="facility_reservation">
										<FacilityReservation />
									</TabPane>
									<TabPane tab="Equipment" key="equipments">
										<Equipments />
									</TabPane>
									{/* <TabPane tab="Certificates" key="certificates">
										<Certificates />
									</TabPane> */}
								</Tabs>
							</div>
						</div>
					</div>
				</div>
			</React.Fragment>
		)
	}
}

const composed = compose(
	inject('AuthStore'),
	observer
)

export default composed(Index)
